import { render, staticRenderFns } from "./HomepageComunication.vue?vue&type=template&id=1318c7d7"
import script from "./HomepageComunication.vue?vue&type=script&lang=js"
export * from "./HomepageComunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports